import { createFileRoute } from "@tanstack/react-router";
import { Preispruefung } from "../../features/shell/Preispruefung";

export const Route = createFileRoute("/preispruefung/$vertragId")({
  component: PreispruefungRoute,
});

function PreispruefungRoute() {
  const { vertragId } = Route.useParams();
  return <Preispruefung vertragId={vertragId} />;
}
